import { Box, Button, Grid, MenuItem, Paper, Select, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import useBackdrop from '../../../hooks/useBackdrop';
import useConfirmDialog from '../../../hooks/useConfirmDialog';
import { HomeShape, HomeStyleType } from '../../../services/types';
import useStyles from './styles';
import { createHomeDisplayStyle } from '../../../services/api/DisplayStyle';

interface IProps {
  onCreate: () => void;
  onError: (e?: any) => void;
}

const CreateDisplayStyle = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const [styleTitle, setStyleTitle] = useState<string>('');
  const [styleType, setStyleType] = useState<HomeStyleType>(HomeStyleType.Card);
  const [styleShape, setStyleShape] = useState<HomeShape>(HomeShape.HorizontalRectangle);
  const [numberOfDisplay, setNumberOfDisplay] = useState<number>(1);
  const [requiredVersion, setRequiredVersion] = useState<string>('');

  const confirm = useConfirmDialog();
  const backdrop = useBackdrop();

  const onSave = () => {
    const onProceed = async () => {
      try {
        backdrop.show();
        await createHomeDisplayStyle({
          title: styleTitle.toString(),
          type: styleType,
          shape: styleShape,
          numberOfDisplay,
          requiredVersion: requiredVersion.toString(),
        });

        initialize();
        props.onCreate();
      } catch (e) {
        props.onError();
        return;
      } finally {
        backdrop.hide();
      }
    };

    confirm.open({
      onProceed,
    });
  };

  const initialize = () => {
    setStyleTitle('');
    setStyleType(HomeStyleType.Card);
    setStyleShape(HomeShape.HorizontalRectangle);
    setNumberOfDisplay(1);
    setRequiredVersion('');
  };

  return (
    <div>
      <Paper className={classes.createRoot}>
        <Typography variant="h6" component="h3" className={classes.mainTitle}>
          Create a Display Style
        </Typography>
        <Grid container>
          <Grid item xs={12}>
            <Grid container className={classes.row}>
              <Grid item xs={3}>
                <Typography variant="subtitle1">Style Title</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  placeholder="Style Title"
                  fullWidth
                  value={styleTitle}
                  onChange={e => {
                    setStyleTitle(e.target.value);
                  }}
                ></TextField>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container className={classes.row}>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Style Type</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select fullWidth value={styleType} onChange={e => setStyleType(String(e.target.value) as HomeStyleType)}>
                    <MenuItem value={HomeStyleType.Card}>Card</MenuItem>
                    <MenuItem value={HomeStyleType.List}>List</MenuItem>
                    <MenuItem value={HomeStyleType.Banner}>Banner</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container className={classes.row}>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Shape</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select fullWidth value={styleShape} onChange={e => setStyleShape(String(e.target.value) as HomeShape)}>
                    <MenuItem value={HomeShape.HorizontalRectangle}>Horizontal Rectangle</MenuItem>
                    <MenuItem value={HomeShape.VerticalRectangle}>Vertical Rectangle</MenuItem>
                    <MenuItem value={HomeShape.Square}>Square</MenuItem>
                    <MenuItem value={HomeShape.Circle}>Circle</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container className={classes.row}>
                <Grid item xs={3}>
                  <Typography variant="subtitle1"># of Display</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select fullWidth value={numberOfDisplay} onChange={e => setNumberOfDisplay(Number(e.target.value).valueOf())}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={1.5}>1.5</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container className={classes.row}>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Required Version</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    placeholder="Required Version"
                    fullWidth
                    value={requiredVersion}
                    onChange={e => {
                      setRequiredVersion(String(e.target.value));
                    }}
                  ></TextField>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box>
          <Button variant="contained" color="primary" onClick={onSave}>
            SAVE
          </Button>
        </Box>
      </Paper>
    </div>
  );
};

export default CreateDisplayStyle;
